import moment from 'moment-timezone'
import { getUserTimeZone } from '@/utils/timeZone'
import { INACTIVE_USER_VISIBLE_DAYS } from '../constants'
import { user } from '../types'

type IsAdminVisibleUserOptions = {
  now?: moment.MomentInput
  timeZone?: string
}

export const isAdminVisibleUser = (
  user: user,
  options: IsAdminVisibleUserOptions = {}
) => {
  if (user?.is_active !== false) return true
  if (!user?.updated_on) return false

  const normalizedOptions =
    options && typeof options === 'object' && !Array.isArray(options)
      ? options
      : {}
  const timeZone = normalizedOptions.timeZone || getUserTimeZone()
  const updatedOn = moment(user.updated_on).tz(timeZone)
  if (!updatedOn.isValid()) return false

  const visibleFrom = moment(normalizedOptions.now)
    .tz(timeZone)
    .startOf('day')
    .subtract(INACTIVE_USER_VISIBLE_DAYS, 'days')

  return updatedOn.startOf('day').isSameOrAfter(visibleFrom)
}
